import { Component, defineComponent } from '@decify/cell-shopify/client';
import './LanguageSelector.scss';
export const languageSelectorName = 'LanguageSelector';
export const languageSelectorTagName = 'cell-component-language-selector';
export class LanguageSelector extends Component {
    elements;
    constructor() {
        super(languageSelectorName);
        const formElement = this.querySelector('form');
        if (!formElement) {
            throw new Error('LanguageSelector component is missing the form element.');
        }
        const languageCodeInputElement = this.querySelector('input[name="language_code"]');
        if (!languageCodeInputElement) {
            throw new Error('LanguageSelector component is missing the language code input element.');
        }
        const selectElement = this.querySelector('select');
        if (!selectElement) {
            throw new Error('LanguageSelector component is missing the select element.');
        }
        this.elements = {
            form: formElement,
            input: languageCodeInputElement,
            select: selectElement,
        };
        this.handleSelectChangeEvent = this.handleSelectChangeEvent.bind(this);
    }
    componentDidMount() {
        this.elements.select.subscribe('change', this.handleSelectChangeEvent);
    }
    handleSelectChangeEvent() {
        const selectedValue = this.elements.select.value;
        this.elements.input.value = selectedValue;
        this.elements.form.submit();
    }
}
defineComponent(languageSelectorTagName, LanguageSelector);
